"use client";
import { useEffect } from "react";

import { Module } from "../layouts";

export default function Advertisement() {
  useEffect(() => {
    try {
      (window.adsbygoogle || []).push({});
    } catch (e) {
      // no-op
    }
  }, []);

  return <Module>
    <ins
      className="adsbygoogle"
      style={{ display: "block" }}
      data-ad-client="ca-pub-5569600601154152"
      data-ad-slot="4798805423"
      data-ad-format="auto"
      data-full-width-responsive="true"
    />
  </Module>
}